import React, { useEffect, useState } from "react";
import MainLayout from "../../Layout/mainLayout";
import { useDispatch, useSelector } from "react-redux";
import { getEnums } from "../../Redux/Actions/enumsActions";
import { viewCategoryList } from "../../Redux/Actions/categoryActions";
import { viewUnitList } from "../../Redux/Actions/unitsActions";
import { addNewAmenities } from "../../Redux/Actions/amenitiesResaleActions";
import AddImage from "../../Global Functions/addImage";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import "./addAmenities.css";

const UploadIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
    <polyline points="17 8 12 3 7 8" />
    <line x1="12" y1="3" x2="12" y2="15" />
  </svg>
);

const TrashIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="3 6 5 6 21 6" />
    <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
    <path d="M10 11v6M14 11v6" />
    <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
  </svg>
);

const AddAmenities = () => {
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { categories } = useSelector((state) => state.categories);
  // const { units } = useSelector((state) => state.units);
  const { enumsData } = useSelector((state) => state.enumsData);

  const [activeSection, setActiveSection] = useState(0);
  const [subCategoryList, setSubCategoryList] = useState({});
  const [loading, setLoading] = useState(false);

  const [amenityData, setAmenityData] = useState({
    amenityName: "",
    position: Math.floor(Math.random() * 1000) + 1,
    category: "",
    project_type: "",
    unit: "",
    amenitiesFor: "",
    image: "",
    business_type: [],
  });

  useEffect(() => {
    const payloadData = { page: 1, limit: 1000 };
    dispatch(viewCategoryList(payloadData));
    dispatch(viewUnitList(payloadData));
    dispatch(getEnums());
  }, [dispatch]);

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;
    const imageUrl = await AddImage(file);
    if (imageUrl) {
      setAmenityData((prev) => ({ ...prev, image: imageUrl }));
    }
  };

  const handleCategoryChange = async (event) => {
    const categoryId = event.target.value;
    setAmenityData((prev) => ({ ...prev, project_type: categoryId }));
    try {
      const response = await axios.post(
        `${BASE_URL}/category/list`,
        { page: 1, limit: 1000, category_id: categoryId },
        { headers: { "Content-Type": "application/json" } }
      );
      setSubCategoryList(response.data);
    } catch (error) {
      console.error("Error fetching subcategories:", error);
    }
  };


  const handleReset = () => {
    setAmenityData({
      amenityName: "",
      position: Math.floor(Math.random() * 1000) + 1,
      category: "",
      project_type: "",
      unit: "",
      amenitiesFor: "",
      image: "",
    });
    setSubCategoryList({});
    setActiveSection(0);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!amenityData.amenitiesFor) return toast.error("Please select what the amenity is for");
    if (!amenityData.project_type) return toast.error("Category is required");
    if (!amenityData.amenityName?.trim()) {
      return toast.error("Amenity title is required");
    }

    setLoading(true);
    try {
      let filteredData = { ...amenityData };
      Object.keys(filteredData).forEach((key) => {
        if (filteredData[key] === "" || filteredData[key] === null) {
          delete filteredData[key];
        }
      });
      const response = await dispatch(addNewAmenities(filteredData));
      if (response?.statusCode === 200) {
        // toast.success("Amenity added successfully!");
        handleReset();
        navigate("/amenities");
      } else {
        toast.error(response?.message || "Failed to add amenity");
      }
    } catch (error) {
      toast.error(error?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const sections = ["Amenity For", "Category", "Details & Icon"];

  const handleNextSection = () => {
    if (activeSection === 0 && !amenityData.amenitiesFor) {
      toast.error("Please select what the amenity is for");
      return;
    }
    if (activeSection === 1 && !amenityData.project_type) {
      toast.error("Please select a category");
      return;
    }
    setActiveSection((s) => Math.min(sections.length - 1, s + 1));
  };

  return (
    <MainLayout>
      <div className="ab-wrapper">
        <div className="ab-header">
          <div className="ab-header-left">
            <div className="ab-header-icon">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
              </svg>
            </div>
            <div>
              <h1 className="ab-title">Add Resale Amenity</h1>
              <p className="ab-subtitle">Fill in the details to add a new amenity</p>
            </div>
          </div>
          <Link to="/amenities" className="ab-view-btn">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
            </svg>
            View Amenity List
          </Link>
        </div>

        <div className="ab-nav">
          {sections.map((sec, i) => (
            <button
              key={i}
              className={`ab-nav-pill ${activeSection === i ? "ab-nav-pill--active" : ""}`}
              onClick={() => setActiveSection(i)}
              type="button"
              disabled={loading}
            >
              <span className="ab-nav-num">{String(i + 1).padStart(2, "0")}</span>
              {sec}
            </button>
          ))}
        </div>

        <form className="ab-form">
          <div className={`ab-section ${activeSection === 0 ? "ab-section--visible" : ""}`}>
            <div className="ab-section-header">
              <span className="ab-section-badge">01</span>
              <h2 className="ab-section-title">Amenity For</h2>
            </div>
            <div className="ab-grid ab-grid-2">
              <div className="ab-field">
                <label className="ab-label">Select Amenity For <span className="ab-req">*</span></label>
                <select
                  className="ab-select"
                  value={amenityData.amenitiesFor}
                  onChange={(e) => setAmenityData((prev) => ({ ...prev, amenitiesFor: e.target.value }))}
                  disabled={loading}
                >
                  <option value="">Select an option</option>
                  {enumsData?.data?.AmenityFor &&
                    Object.entries(enumsData.data.AmenityFor).map(([key, value]) => (
                      <option key={key} value={value}>
                        {value.charAt(0).toUpperCase() + value.slice(1)}
                      </option>
                    ))}
                </select>
              </div>


              <div className="asb-field" ab-grid-2>
                <label className="asb-label">Business Type <span className="asb-optional">(Optional)</span></label>
                <div className="asb-checkbox-group">
                  {["fresh", "resale", "business", "rental"].map((type) => (
                    <label key={type} className="asb-checkbox-label">
                      <input
                        type="checkbox"
                        value={type}
                        checked={amenityData.business_type.includes(type)}
                        onChange={(e) => {
                          const { value, checked } = e.target;
                          setAmenityData((prev) => ({
                            ...prev,
                            business_type: checked
                              ? [...prev.business_type, value]
                              : prev.business_type.filter((t) => t !== value),
                          }));
                        }}
                        disabled={loading}
                      />
                      {type.charAt(0).toUpperCase() + type.slice(1)}
                    </label>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className={`ab-section ${activeSection === 1 ? "ab-section--visible" : ""}`}>
            <div className="ab-section-header">
              <span className="ab-section-badge">02</span>
              <h2 className="ab-section-title">Category</h2>
            </div>
            <div className="ab-grid ab-grid-2">
              <div className="ab-field">
                <label className="ab-label">Select Category <span className="ab-req">*</span></label>
                <select
                  className="ab-select"
                  name="project_type"
                  value={amenityData.project_type}
                  onChange={handleCategoryChange}
                  disabled={loading}
                >
                  <option value="">Select an option</option>
                  {Array.isArray(categories?.data) &&
                    categories.data.map((cat) => (
                      <option key={cat._id} value={cat._id}>{cat.name}</option>
                    ))}
                </select>
              </div>
              <div className="ab-field">
                <label className="ab-label">
                  Select Sub-Category <span className="ab-optional">(Optional)</span>
                </label>
                <select
                  className={`ab-select ${!amenityData.project_type ? "ab-select--disabled" : ""}`}
                  value={amenityData.category}
                  onChange={(e) => setAmenityData((prev) => ({ ...prev, category: e.target.value }))}
                  disabled={!amenityData.project_type || loading}
                >
                  <option value="">{!amenityData.project_type ? "Select category first" : "Select sub-category"}</option>
                  {Array.isArray(subCategoryList?.data) &&
                    subCategoryList.data.map((sub) => (
                      <option key={sub._id} value={sub._id}>{sub.name}</option>
                    ))}
                </select>
              </div>
            </div>
          </div>

          <div className={`ab-section ${activeSection === 2 ? "ab-section--visible" : ""}`}>
            <div className="ab-section-header">
              <span className="ab-section-badge">03</span>
              <h2 className="ab-section-title">Details & Icon</h2>
            </div>
            <div className="ab-grid ab-grid-2">
              <div className="ab-field">
                <label className="ab-label">Amenity Title <span className="ab-req">*</span></label>
                <input
                  className="ab-input"
                  type="text"
                  name="amenityName"
                  value={amenityData.amenityName}
                  onChange={(e) => setAmenityData((prev) => ({ ...prev, amenityName: e.target.value }))}
                  placeholder="e.g. Swimming Pool"
                  disabled={loading}
                />
              </div>

              {/* {amenityData.amenitiesFor === "unit" && (
                <div className="ab-field">
                  <label className="ab-label">Select Unit Type <span className="ab-req">*</span></label>
                  <select
                    className="ab-select"
                    name="unit"
                    value={amenityData.unit}
                    onChange={(e) => setAmenityData((prev) => ({ ...prev, unit: e.target.value }))}
                    disabled={loading}
                  >
                    <option value="">Select an option</option>
                    {Array.isArray(units?.data) &&
                      units.data.map((unit) => (
                        <option key={unit._id} value={unit._id}>{unit.name}</option>
                      ))}
                  </select>
                </div>
              )} */}

              <div className="ab-field ab-field--full">
                <label className="ab-label">Amenity Icon <span className="ab-req">*</span></label>
                {amenityData.image ? (
                  <div className="aa-image-preview">
                    <img src={amenityData.image} alt="Amenity icon" className="aa-preview-img" />
                    <div className="aa-preview-info">
                      <span className="aa-preview-label">Icon uploaded</span>
                      <button
                        type="button"
                        className="aa-remove-btn"
                        onClick={() => setAmenityData((prev) => ({ ...prev, image: "" }))}
                        disabled={loading}
                      >
                        <TrashIcon />
                        Remove
                      </button>
                    </div>
                  </div>
                ) : (
                  <label className="aa-upload-zone" htmlFor="amenity-image">
                    <input
                      id="amenity-image"
                      type="file"
                      name="image"
                      accept="image/*"
                      style={{ display: "none" }}
                      onChange={handleFileChange}
                      disabled={loading}
                    />
                    <div className="aa-upload-icon">
                      <UploadIcon />
                    </div>
                    <span className="aa-upload-text">Click to upload icon</span>
                    <span className="aa-upload-hint">PNG, JPG, SVG up to 2MB</span>
                  </label>
                )}
              </div>
            </div>
          </div>

          <div className="ab-footer">
            <div className="ab-footer-nav">
              <button
                type="button"
                className="ab-btn ab-btn--ghost"
                onClick={() => setActiveSection((s) => Math.max(0, s - 1))}
                disabled={activeSection === 0 || loading}
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <polyline points="15 18 9 12 15 6" />
                </svg>
                Back
              </button>

              {activeSection < sections.length - 1 ? (
                <button type="button" className="ab-btn ab-btn--primary" onClick={handleNextSection} disabled={loading}>
                  Next
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <polyline points="9 18 15 12 9 6" />
                  </svg>
                </button>
              ) : (
                <button type="button" onClick={handleSubmit} className="ab-btn ab-btn--submit" disabled={loading}>
                  {loading ? (
                    "Saving..."
                  ) : (
                    <>
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                        <polyline points="20 6 9 17 4 12" />
                      </svg>
                      Save Amenity
                    </>
                  )}
                </button>
              )}
            </div>
            <Link to="/amenities" className="ab-btn ab-btn--cancel" onClick={handleReset}>
              Cancel
            </Link>
          </div>
        </form>
      </div>
    </MainLayout>
  );
};

export default AddAmenities;